import React from 'react';

const LoadingComponent = () => {
  return (
    <div class="spinner-border mx-2 spinner-border-sm" role="status">
      <span class="sr-only"></span>
    </div>
  );
}

export default LoadingComponent;
